import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApprovalsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Approvals",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M30 16c0-1.15-2.31-1.99-2.6-3.06-.29-1.1 1.28-2.98.73-3.95-.57-.97-2.98-.55-3.78-1.34-.8-.8-.36-3.21-1.34-3.78-.96-.56-2.84 1.03-3.95.73C17.99 4.32 17.16 2 16 2s-1.99 2.31-3.06 2.6c-1.1.29-2.98-1.28-3.95-.73-.97.57-.55 2.98-1.34 3.78-.8.8-3.21.36-3.78 1.34-.56.96 1.03 2.84.73 3.95C4.32 14.01 2 14.84 2 16s2.31 1.99 2.6 3.06c.29 1.1-1.28 2.98-.73 3.95.57.97 2.98.55 3.78 1.34.8.8.36 3.21 1.34 3.78.96.56 2.84-1.03 3.95-.73 1.07.28 1.9 2.6 3.06 2.6s1.99-2.31 3.06-2.6c1.1-.29 2.98 1.28 3.95.73.97-.57.55-2.98 1.34-3.78.8-.8 3.21-.36 3.78-1.34.56-.96-1.03-2.84-.73-3.95.28-1.07 2.6-1.9 2.6-3.06m-6.46-2.94-8.61 8.61c-.25.25-.58.38-.93.38s-.68-.13-.93-.39l-4.59-4.59a1.33 1.33 0 0 1 1.88-1.88l3.66 3.66 7.68-7.68a1.33 1.33 0 0 1 1.88 1.88h-.02Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.86 31.86c-8.83 0-16-7.18-16-16s7.17-16 16-16 16 7.17 16 16-7.18 16-16 16m0-29.72C8.3 2.14 2.15 8.29 2.15 15.85S8.3 29.56 15.86 29.56s13.71-6.15 13.71-13.71S23.42 2.14 15.86 2.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.3 21.21c-.3 0-.59-.12-.81-.33l-4.16-4.16c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l3.35 3.35 6.46-6.46c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62l-7.27 7.27c-.21.21-.5.33-.81.33"
      })]
    })
  }));
};
ApprovalsIcon.displayName = 'ApprovalsIcon';